/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var Observable = require('rxjs/Observable');
var interval = require('rxjs/observable/interval');
var first = require('rxjs/operator/first');
var map = require('rxjs/operator/map');
var skipWhile = require('rxjs/operator/skipWhile');
var toPromise = require('rxjs/operator/toPromise');

/**
 * Basic mixin for ol components that depends on map instance
 */

var useMapCmp = {
  methods: {
    /**
     * @return {Promise<void>}
     * @protected
     */
    beforeInit: function beforeInit() {
      var _context,
          _this = this;

      return (_context = (_context = (_context = (_context = interval.interval.call(Observable.Observable, 100), skipWhile.skipWhile).call(_context, function () {
        return !_this.$map;
      }), first.first).call(_context), map.map).call(_context, function () {
        return _this;
      }), toPromise.toPromise).call(_context, _Promise);
    }
  }
};

module.exports = useMapCmp;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/use-map-cmp.js
// module id = 58
// module chunks = 1